namespace GeniuzPOS.Lookups {
    export interface VwArticleRow {
        Id?: number;
        ArticleSeasonCode?: string;
        ArticleSeasonName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace VwArticleRow {
        export const idProperty = 'ArticleSeasonCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Lookups.VwArticle';
        export const lookupKey = 'Lookups.VwArticle';

        export function getLookup(): Q.Lookup<VwArticleRow> {
            return Q.getLookup<VwArticleRow>('Lookups.VwArticle');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ArticleSeasonCode = "ArticleSeasonCode",
            ArticleSeasonName = "ArticleSeasonName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
